/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Solvency, SolvencyInterface } from "../Solvency";

const _abi = [
  {
    inputs: [],
    name: "DifferentArrayLength",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedLTVType",
    type: "error",
  },
];

const _bytecode =
  "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea26469706673582212204d679ee7d2f390477a76e4700ffe1c75f70b047c9cd5d849ff4826f324ecf62c64736f6c634300080d0033";

type SolvencyConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SolvencyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Solvency__factory extends ContractFactory {
  constructor(...args: SolvencyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Solvency";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Solvency> {
    return super.deploy(overrides || {}) as Promise<Solvency>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Solvency {
    return super.attach(address) as Solvency;
  }
  connect(signer: Signer): Solvency__factory {
    return super.connect(signer) as Solvency__factory;
  }
  static readonly contractName: "Solvency";
  public readonly contractName: "Solvency";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SolvencyInterface {
    return new utils.Interface(_abi) as SolvencyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Solvency {
    return new Contract(address, _abi, signerOrProvider) as Solvency;
  }
}
